import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menjing",
  "use": "icon-menjing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menjing\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 0l0 1024 832 0L896 0 64 0zM832 960 128 960 128 64l704 0L832 960zM768 128 192 128l0 768 576 0L768 128zM704 832 256 832 256 192l448 0L704 832zM640 576 576 576 576 448l64 0L640 576z\" p-id=\"73907\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol